import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import { useFeatureStore } from '@/apps/order/stores';
import { useOrdersCreateCalculatorStore, useOrdersCreateFormDataStore } from '@/apps/order/stores/ordersCreate';
import OrderAPI from '@/apps/order/classes/api/OrderAPI';
import DataPreparedParamsInterface from '@/apps/order/interfaces/ordersCreate/DataPreparedParamsInterface';

let alreadyFetched = false;

const hasFeatures = async (): Promise<void> => new Promise<void>((resolve, reject) => {
  nextTick(async () => {
    try {
      const featureStore = useFeatureStore();
      const dataPreparedStore = useOrdersCreateCalculatorStore();
      const { brands } = dataPreparedStore;

      if (!alreadyFetched) {
        const calculatorStore = useOrdersCreateCalculatorStore();
        const { formData: calculatorFormData } = storeToRefs(calculatorStore);

        const params: DataPreparedParamsInterface = {};
        if (calculatorFormData.value.salesPartnerNumber) {
          params.salesPartnerNumber = calculatorFormData.value.salesPartnerNumber;
        }

        await OrderAPI.fetchDataPreparedStepCalculator(params).then((data) => {
          dataPreparedStore.updateByDataPrepared(data);
        });

        const ordersCreateFormDataStore = useOrdersCreateFormDataStore();
        const { formData } = storeToRefs(ordersCreateFormDataStore);

        await featureStore.fetch();

        let brandId = formData.value.calculator?.brand_id || calculatorFormData.value.brand_id;
        if (brands && brands.length > 0 && !brandId) {
          brandId = brands[0].id;
        }

        if (featureStore.referralMarketingIsActive) {
          await featureStore.fetchReferralMarketingRewards(brandId);
        }

        alreadyFetched = true;
      }

      resolve();
    } catch (e) {
      reject(new Error(['fetch for features or referral marketing rewards failed', e].join(' ')));
    }
  });
});

export default hasFeatures;
